import H3 from './H3';
import { Link } from "react-router-dom";

import { formatDate } from '../utils/format-dates';
import { slugify } from '../utils/slugify';

export default function Post({ post }) {
  return (
    <div className="py-8">
      <span className="text-xs font-medium text-bahyellow uppercase tracking-widest">{formatDate(new Date(post.date))}</span>
      <Link
        to={`/posts/${post.id}/${slugify(post.title)}`}
        onClick={() => { window.scroll({ top: 0, left: 0, behavior: "instant" }); }}
        className="block mt-1 group"
      >
        <H3 className="group-hover:text-gray-600 transition-colors">{post.title}</H3>
      </Link>
      {post.authors &&
        <div className="mt-1.5 flex flex-wrap gap-x-2 text-sm text-gray-500">
          {post.authors.map((author, index) =>
            <span key={author.name}>
              {index > 0 ? '· ' : ''}
              <a href={author.link} target="_blank" rel="noopener noreferrer" className="hover:text-gray-800 transition-colors">{author.name}</a>
            </span>
          )}
        </div>
      }
      <div className="mt-4 post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
    </div>
  )
}
